import React, { createContext, useContext, useState, useCallback } from 'react';
import { Loader2 } from 'lucide-react';

/**
 * 🎯 全局项目切换加载状态管理
 *
 * 用于在所有项目切换场景下显示统一的加载反馈：
 * - Dashboard 项目卡片点击
 * - AssetDrawer 切换项目
 * - 新建项目跳转
 * - 其他任何 navigate(`/editor/${id}`) 的地方
 */

const ProjectLoadingContext = createContext(null);

export function ProjectLoadingProvider({ children }) {
  const [loadingProjectId, setLoadingProjectId] = useState(null);

  const startLoading = useCallback((projectId) => {
    setLoadingProjectId(projectId);
  }, []);

  const stopLoading = useCallback(() => {
    setLoadingProjectId(null);
  }, []);

  return (
    <ProjectLoadingContext.Provider value={{ loadingProjectId, startLoading, stopLoading }}>
      {children}

      {/* 全屏加载遮罩 */}
      {loadingProjectId && (
        <div style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          background: 'rgba(0, 0, 0, 0.7)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          backdropFilter: 'blur(8px)'
        }}>
          <div style={{ textAlign: 'center', color: '#fff' }}>
            <Loader2
              size={56}
              style={{
                animation: 'spin 1s linear infinite',
                marginBottom: 16,
                color: '#3b82f6'
              }}
            />
            <div style={{ fontSize: 20, fontWeight: 600, color: '#fff' }}>
              正在打开舞台...
            </div>
            <div style={{ fontSize: 14, color: 'rgba(255,255,255,0.7)', marginTop: 8 }}>
              请稍候
            </div>
          </div>
        </div>
      )}
    </ProjectLoadingContext.Provider>
  );
}

export function useProjectLoading() {
  const context = useContext(ProjectLoadingContext);
  if (!context) {
    throw new Error('useProjectLoading must be used within ProjectLoadingProvider');
  }
  return context;
}
